<div class="container" [ngClass]="{'no-padding-top': isSticky}" (scroll)="onScroll($event)">
  <div class="header">
    <img (click)="close()" id="chavron" src="assets/icons/chavron-right.svg" />
    <div class="heading-content">
      <div class="title">{{ moduleName }}</div>
    </div>
  </div>
  <div class="heading" [ngClass]="{'sticky': isSticky}" #wrapper>{{ call?.callName }}</div>

  <div class="body">
    <h3>{{'reporting.CALL_DETAILS' | transloco}}</h3>
    <div class="description-wrapper">
      <div class="left-container">
        <div class="description">
          <div class="description-content" *ngIf="call?.description">
            <p [ngClass]="{'full-width': !call?.callThumbnail}">
              {{
              isExpanded
              ? call?.description
              : (call?.callThumbnail
              ? (call?.description!.length > 175 ? call?.description!.slice(0, 175) + "..." : call?.description)
              : (call?.description!.length > 281 ? call?.description!.slice(0, 281) + "..." : call?.description))
              }}
            </p>
            <div
              *ngIf="(call?.callThumbnail && call?.description!.length > 175) || (!call?.callThumbnail && call?.description!.length > 281)"
              class="cta" (click)="toggleDescription()">
              {{ctaName}}
            </div>
          </div>


        </div>
        <ng-container *ngIf="!isConversationalCallLoading && conversationalCallDetails">
          <div class="call-type">
            <div class="label">{{'reporting.CALL_TYPE' | transloco}}:</div>
            <div class="name">{{'reporting.CONVERSATIONAL_CALL' | transloco}}
              <img src="assets/icons/info-circle-dark-grey.svg"
                (click)="openTooltip($event, 'left', 'call_type', 326, 136)">
            </div>
          </div>

          <div class="call-type">
            <div class="label">{{'reporting.TOTAL_SESSIONS' | transloco}}:</div>
            <div class="name">{{conversationalCallDetails.practicesCountPerCall}}
              <img src="assets/icons/info-circle-dark-grey.svg"
                (click)="openTooltip($event, 'left', 'session', 326, 96)">
            </div>
          </div>

          <div class="call-type">
            <div class="label">{{'reporting.WHAT_WE_MEASURED' | transloco}}:</div>
            <div class="name">
              <div class="list">
                <div *ngFor="let i of translatedPrompt">
                  {{ 'reporting.' +i | transloco }}
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="right-container" *ngIf="call?.callThumbnail">
        <img [src]="call?.callThumbnail">
        <div *ngIf="call?.avatarName" class="name">{{'reporting.AVATAR' | transloco}}: {{call?.avatarName}}</div>
      </div>

    </div>
  </div>
  <div class="border-seprater" *ngIf="!isConversationalCallLoading && conversationalCallDetails"></div>
  <div class="average-score" *ngIf="!isConversationalCallLoading && conversationalCallDetails">
    <div class="score-heading">{{'reporting.CONVERSATIONAL_AVG_HEADING' | transloco}}</div>
    <div class="details">{{'reporting.OVERALL_SCORE_DETAIL' | transloco}}
      {{conversationalCallDetails.practicesCountPerCall}}
      {{ conversationalCallDetails.practicesCountPerCall > 1
      ? (' ' + ('reporting.TIMES' | transloco))
      : (' ' + ('reporting.TIME' | transloco))
      }} {{'reporting.CALL_RUN' | transloco}}.
    </div>
    <div class="bar-container">
      <div class="progress-bar" *ngIf="
            calculateProgress(
              conversationalCallDetails?.avgCallScore || 0,
              totalScore
            );
            let bar
          ">
        <div class="segment" *ngFor="let i of [].constructor(totalScore); let index = index"
          [class.filled]="index < bar.filled">
          <div class="partial-fill" *ngIf="index === bar.filled && bar.partial > 0" [style.width.%]="bar.partial * 100">
          </div>
        </div>
      </div>
    </div>
    <div class="score-container">
      <div class="achieved-score">
        {{
        conversationalCallDetails.avgCallScore || 0 | number : "1.1-2"
        }}
      </div>
      <div class="total-score">&nbsp;/&nbsp;{{ totalScore }}</div>
    </div>
  </div>
  <div class="border-seprater"></div>
  <div *ngIf="objectivesStatsResponse" class="average-score pb-0">
    <div class="heading">{{'reporting.OBJECTIVES' | transloco}}</div>
    <div class="details">{{'reporting.AVG_OBJECTIVE' | transloco}} {{conversationalCallDetails?.practicesCountPerCall}}
      {{(conversationalCallDetails?.practicesCountPerCall || 0) > 1 ? (' ' + ('reporting.SESSIONS' | transloco)) : (' '
      +('reporting.SESSION' | transloco))}} {{'reporting.OF_THIS_CALL' | transloco}}.</div>
  </div>
  <div *ngIf="objectivesStatsResponse" class="average-facts">
    <div class="question" *ngFor="
        let objective of objectivesStatsResponse?.objectivesStats;
        let i = index
      ">
      <div class="details">
        <div class="title-container">
          <div class="title">{{ objective.objectiveTitle }}</div>
        </div>
        <div class="bar-container">
          <div [ngStyle]="{
              'grid-template-columns':
                'repeat(' + (5) + ', 1fr)'
            }" class="progress-bar" *ngIf="
              calculateProgress(objective.averageScore, 5);
              let bar
            ">
            <div class="segment" *ngFor="
                let i of [].constructor(5);
                let index = index
              " [class.filled]="index < bar.filled">
              <div class="partial-fill" *ngIf="index === bar.filled && bar.partial > 0"
                [style.width.%]="bar.partial * 100"></div>
            </div>
          </div>
        </div>
        <div class="score-container">
          <div class="score">
            {{ objective.averageScore | number:'1.1-2'}}&nbsp;/&nbsp;{{ 5 }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="border-seprater"></div>
  <ng-container *ngIf="isMessageAdherenceV2 &&
    messageAdherenceStatsV2Response &&
    messageAdherenceStatsV2Response.messageSectionScoreStats.length > 0
  ">
    <div class="message-adherence-v2">
      <div class="heading">{{'reporting.MESSAGE_ADHERENCE' | transloco}}</div>
      <div class="details">
        {{'reporting.MESSAGE_ADHERENCE_DETAILS_1' | transloco}}
        {{
        messageAdherenceStatsV2Response.messageSectionScoreStats.length
        }}
        {{'reporting.MESSAGE_ADHERENCE_DETAILS_2' | transloco}}
        {{ messageAdherenceStatsV2Response.sessionsCount }}
        {{
        (messageAdherenceStatsV2Response.sessionsCount || 0) > 1
        ? (' ' + ('reporting.SESSIONS' | transloco))
        : (' ' + ('reporting.SESSION' | transloco))
        }}
        {{'reporting.OF_THIS_CALL' | transloco}}.
      </div>
    </div>
    <div class="average-facts">
      <div class="question" *ngFor="
        let message of messageAdherenceStatsV2Response?.messageSectionScoreStats;
        let i = index
      ">
        <div class="details">
          <div class="title-container">
            <div class="section-name">{{ message.sectionName }}</div>
          </div>
          <div class="bar-container">
            <div [ngStyle]="{
              'grid-template-columns': 'repeat(' + 5 + ', 1fr)'
            }" class="progress-bar" *ngIf="calculateProgressFromPercentage(message.percentageScore, 5); let bar">
              <div class="segment" *ngFor="let i of [].constructor(5); let index = index"
                [class.filled]="index < bar.filled">
                <div class="partial-fill" *ngIf="index === bar.filled && bar.partial > 0"
                  [style.width.%]="bar.partial * 100">
                </div>
              </div>
            </div>
          </div>
          <div class="score-container">
            <div class="percentage-score">
              {{ message.percentageScore }}%
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="border-seprater"></div>
  </ng-container>
  <ng-container *ngIf="messageAdherenceStatsResponse && messageAdherenceStatsResponse.articulationScoreStats
                  && messageAdherenceStatsResponse.articulationScoreStats.length > 0">
    <div class="message-adherence">
      <div class="heading">{{'reporting.MESSAGE_ADHERENCE' | transloco}}</div>
      <div class="details">
        {{'reporting.MESSAGE_ADHERENCE_DETAILS_1' | transloco}}
        {{messageAdherenceStatsResponse.articulationScoreStats.length}} {{'reporting.IMPORTANT_IDEAS' | transloco}}.
        {{'reporting.PERCENT_MESSAGE_ARTICULATED' | transloco}}
        {{messageAdherenceStatsResponse.sessionsCount}} {{(messageAdherenceStatsResponse.sessionsCount || 0) > 1 ? (' '
        + ('reporting.SESSIONS' | transloco)) : (' ' + ('reporting.SESSION' | transloco))}} {{'reporting.OF_THIS_CALL' | transloco}}.
      </div>
      <div class="skills-container">
        <div class="skill">
          <div class="round-shape"></div>
          <span>{{'reporting.FULLY_ARTICULATED' | transloco}}</span>
        </div>
        <div class="skill">
          <div class="round-shape"></div>
          <span>{{'reporting.PARTIALLY_ARTICULATED' | transloco}}</span>
        </div>
        <div class="skill">
          <div class="round-shape"></div>
          <span>{{'reporting.NOT_MENTIONED' | transloco}}</span>
        </div>
      </div>
      <div class="message" *ngFor="let stat of messageAdherenceStatsResponse?.articulationScoreStats">
        <div class="title">
          {{stat.articulationTitle}}
        </div>
        <div class="progress-bar-container">
          <div *ngIf="stat.articulationProgress.get('FULLY_ARTICULATED')?.percentage !== 0" class="progress-wrapper"
            [ngStyle]="{ 'width': (stat.articulationProgress.get('FULLY_ARTICULATED')?.percentage || 0) + '%' }">
            <div class="progress expert" [ngClass]="{
                'right-rounded':
                  stat.articulationProgress.get('PARTIALLY_ARTICULATED')?.percentage === 0 &&
                  stat.articulationProgress.get('NOT_MENTIONED')?.percentage === 0
              }">
            </div>
            <div class="tooltip">
              <img src="/assets/icons/green-circle.svg">
              {{stat.articulationProgress.get('FULLY_ARTICULATED')?.percentage}}%
            </div>
          </div>
          <div *ngIf="stat.articulationProgress.get('PARTIALLY_ARTICULATED')?.percentage !== 0" class="progress-wrapper"
            [ngStyle]="{ 'width': (stat.articulationProgress.get('PARTIALLY_ARTICULATED')?.percentage || 0) + '%' }">
            <div class="progress proficient" [ngClass]="{
                'left-rounded': stat.articulationProgress.get('FULLY_ARTICULATED')?.percentage === 0,
                'right-rounded': stat.articulationProgress.get('NOT_MENTIONED')?.percentage === 0,
              }">
            </div>
            <div class="tooltip">
              <img src="/assets/icons/blue-circle.svg">
              {{stat.articulationProgress.get('PARTIALLY_ARTICULATED')?.percentage}}%
            </div>
          </div>
          <div class="progress-wrapper"
            [ngStyle]="{ 'width': (stat.articulationProgress.get('NOT_MENTIONED')?.percentage || 0) + '%' }">
            <div class="progress developing" [ngClass]="{
                'left-rounded':
                  stat.articulationProgress.get('FULLY_ARTICULATED')?.percentage === 0 &&
                  stat.articulationProgress.get('PARTIALLY_ARTICULATED')?.percentage === 0
              }">
            </div>
            <div class="tooltip">
              <img src="/assets/icons/yellow-circle.svg">
              {{stat.articulationProgress.get('NOT_MENTIONED')?.percentage}}%
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="border-seprater"></div>
  </ng-container>
  <div *ngIf="skillsStatsResponse" class="message-adherence-skills">
    <div class="heading">{{'reporting.SKILLS_LABEL' | transloco}}</div>
    <div class="details">
      {{'reporting.SKILLS_DETAILS' | transloco}} {{conversationalCallDetails?.practicesCountPerCall}}
      {{(conversationalCallDetails?.practicesCountPerCall || 0) > 1 ? (' ' + ('reporting.SESSIONS' | transloco)) : (' ' +
      ('reporting.SESSION' | transloco))}} {{'reporting.OF_THIS_CALL' | transloco}}.
    </div>
    <div class="skills-container">
      <div class="skill">
        <div class="round-shape"></div>
        <span> {{'reporting.DEVELOPING' | transloco}}</span>
      </div>
      <div class="skill">
        <div class="round-shape"></div>
        <span> {{'reporting.PROFICIENT' | transloco}}</span>
      </div>
      <div class="skill">
        <div class="round-shape"></div>
        <span> {{'reporting.Expert' | transloco}}</span>
      </div>
    </div>
    <div class="message" *ngFor="let stat of skillsStatsResponse.skillsScoreStats">
      <div class="title">
        {{stat.skillTitle}}
      </div>
      <div class="progress-bar-container">
        <div class="progress-wrapper" *ngFor="let progress of stat.skillProgress; let i = index"
          [ngStyle]="{ 'width': calculateAdjustedWidth(stat.skillProgress, i) + '%' }">
          <div class="progress" [ngClass]="{
            'developing': i === 0,
            'proficient': i === 1,
            'expert': i === 2,
            'right-rounded': stat.skillProgress[i + 1] && stat.skillProgress[i + 1].progressStatus.percentage === 0
          }">
          </div>
          <div class="tooltip">
            <img [attr.src]="i === 0 ? '/assets/icons/yellow-circle.svg' :
                     i === 1 ? '/assets/icons/blue-circle.svg' :
                     '/assets/icons/green-circle.svg'" alt="{{'reporting.PROGRESS_ICON' | transloco }}">
            {{ calculateAdjustedWidth(stat.skillProgress, i) }}%
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="loader" *ngIf="isConversationalCallLoading">
    <app-three-dots-blinking></app-three-dots-blinking>
  </div>
  <div *ngIf="!isConversationalCallLoading && !conversationalCallDetails" class="no-result">
    <div class="emoji-container">
      <img src="assets/icons/emoji_face-in-clouds.svg" alt="" />
    </div>
    <div class="text-container">
      <div>{{'reporting.NO_RESULT' | transloco}}!</div>
      <div>
        {{'reporting.NO_RESULT_TEXT' | transloco}}!
      </div>
    </div>
  </div>

</div>